// // Import the functions you need from the SDKs you need
// import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
// import { getAuth } from "firebase/auth";
// // TODO: Add SDKs for Firebase products that you want to use
// // https://firebase.google.com/docs/web/setup#available-libraries

// // Your web app's Firebase configuration
// // For Firebase JS SDK v7.20.0 and later, measurementId is optional
// const firebaseConfig = {
//   apiKey: "AIzaSyBjWMBEDBaP5g5-oKFEFcj2rIXcZ69UmJc",
//   authDomain: "oauthapp-49ea2.firebaseapp.com",
//   projectId: "oauthapp-49ea2",
//   storageBucket: "oauthapp-49ea2.appspot.com",
//   messagingSenderId: "197465967376",
//   appId: "1:197465967376:web:8599b6ea17f0920e9a7395",
//   measurementId: "G-XW0SNL2QXD"
// };

// // Initialize Firebase
// export const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);
// export const auth=getAuth(app);



// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import {getAuth} from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAj5UaIXaNRt6tgPxhpw6jz59h71XnnPzc",
  authDomain: "oauthapp-e6ae8.firebaseapp.com",
  projectId: "oauthapp-e6ae8",
  storageBucket: "oauthapp-e6ae8.appspot.com",
  messagingSenderId: "24653701581",
  appId: "1:24653701581:web:cdb0b263ddfb91d0b02484",
  measurementId: "G-BDL9WS4J54"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
export const auth=getAuth(app);